import { useMemo } from "react";
import axios from "axios";
import { useAuth } from "@clerk/react";
import { useQuery } from "@tanstack/react-query";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const useApi = () => {
  const { getToken } = useAuth();
  return useMemo(() => {
    const inst = axios.create({ baseURL: `${BACKEND_URL}/api` });
    inst.interceptors.request.use(async (cfg) => {
      const t = await getToken();
      if (t) cfg.headers.Authorization = `Bearer ${t}`;
      return cfg;
    });
    return inst;
  }, [getToken]);
};

export const useMe = () => {
  const api = useApi();
  const { isSignedIn } = useAuth();
  return useQuery({ queryKey: ["me"], queryFn: async () => (await api.get("/me")).data, enabled: !!isSignedIn, staleTime: 15_000 });
};

export const errMsg = (e, fallback = "Something went wrong") => e?.response?.data?.detail || fallback;

export const fmtBytes = (b) => {
  if (!b) return "0 B";
  const u = ["B", "KB", "MB", "GB"];
  const i = Math.min(Math.floor(Math.log(b) / Math.log(1024)), 3);
  return `${(b / 1024 ** i).toFixed(i ? 1 : 0)} ${u[i]}`;
};

export const fmtDate = (iso) =>
  new Date(iso).toLocaleString(undefined, { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" });

export const fmtDay = (iso) => new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
